import { isNil, isEmpty } from 'ramda';
import loadingTemplate from './loading.tpl.html';

export class Loading {
  constructor($scope, $ngRedux, actionsFactory, $translate) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
    });
    const unsubscribe = $ngRedux.connect(this.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);
  }

  hasMessage() {
    return !isNil(this.messageKey) && !isEmpty(this.messageKey);
  }
}

Loading.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
];

export const loading = {
  template: loadingTemplate,
  controller: Loading,
  bindings: {
    messageKey: '<?',
  },
};
